module.exports = __webpack_public_path__ + "static/media/clover-station-pos-device-full-service-restaurant-large.94b4c4d9.jpg";